<template>
  <VipCustomer
    @close="close" 
    @openUrl="openUrl"
  ></VipCustomer>
</template>

<script>
import VipCustomer from "@/components/VipCustomer.vue";
import { registReturnGameFunction, gameOpenDownloads } from '@/bridge/AppJsBridge'
import { mapActions } from 'vuex';

export default {
  name: '',
  data () {
    return {
    };
  },
  mounted() {   
    this.getCache() 
  },
  components: {
    VipCustomer
  },
  methods: {
    ...mapActions({
      getCache: 'user/getCacheState'
    }),
    close() {
      registReturnGameFunction(null)
    },
    openUrl(url) {
      gameOpenDownloads({
        gameUrl: url
      })
    }
  }
}
</script>